export default "__VITE_ASSET__CuxrZkFk__"